import script from "./aboutEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./aboutEvent.vue?vue&type=script&setup=true&lang=js"

import "./aboutEvent.vue?vue&type=style&index=0&id=6ac0d75c&lang=css"

const __exports__ = script;

export default __exports__